module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2e13cc4e6bf302ef51a8eece44ee0b91.png";